import { Component, OnInit, Inject, ElementRef, ViewChild, Renderer2 } from '@angular/core';

import { SnackbarService } from './../snackbar/snackbar.service';
import { SheetjsService } from '../../services/sheetjs/sheetjs.service';
import { ExcelImportModal } from './excel-import-modal-interface/excel-import-modal.interface';
import { excelImportConfig } from './excel-import-modal.config';
import { XlsxService } from '../../services/xlsx.service';
import { reportField } from '../../../core/configs/trip-mode.config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-excel-import-modal',
  templateUrl: './excel-import-modal.component.html',
  styleUrls: ['./excel-import-modal.component.scss']
})
export class ExcelImportModalComponent implements OnInit {
  @ViewChild('inputExcel') file: ElementRef;

  fileValue;
  excelFormatName;
  excelImportConfig: ExcelImportModal;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ExcelImportModalComponent>,
    private renderer: Renderer2,
    private sheetjsService: SheetjsService,
    private snackBarService: SnackbarService,
    private xlsxService: XlsxService
  ) { }

  ngOnInit() {
    this.excelImportConfig = this.data.config ? this.data.config : excelImportConfig[this.data.type];
  }

  onNoClick(event?): void {
    this.dialogRef.close({ event });
  }

  uploadExcel() {
    this.renderer.selectRootElement(this.file.nativeElement).click();
  }

  groupBy(data, key) {
    return data.reduce((groups, item) => {
      const value = item[key];
      groups[value] = groups[value] || [];
      groups[value].push(item);
    return groups; }, []);
  }

  validateDuplicate(data) {
    let duplicateTrip = false;
    let dispatches = this.groupBy(data.slice(1),2)
    Object.keys(dispatches).forEach((key) => {
      const value = dispatches[key];
      let trips = this.groupBy(value,0)
      duplicateTrip = duplicateTrip || Object.keys(trips).length > 1
    });
    return duplicateTrip
  }

  upload(event) {
    if (event) {
      let exist:any;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const data = <any[]>this.xlsxService.importFromFile(e.target.result);
        let validFormat = false;
        let duplicateTrip = false;
        const importHeader = data[0];

        if (this.excelImportConfig.multiple) {
          exist = this.excelImportConfig.templateList.find(element => JSON.stringify(element.headers) === JSON.stringify(importHeader));
          validFormat = exist && (exist.tripModes.find(element => element === this.data.parameter)) ? true : false;
        } else {
          validFormat = JSON.stringify(this.excelImportConfig.headers) === JSON.stringify(importHeader);
        }
        if(exist && exist.formatType === reportField.DISPATCHES_TO_LOAD_TRIP) {
          duplicateTrip = this.validateDuplicate(data);
        }
        if(duplicateTrip) {
          this.snackBarService.show('Asegúrate de no repetir despachos entre viajes', 'warning');
        } else {
          if (validFormat) {
            if (data && data.length >= 2) {
              this.onNoClick({
                type: exist? exist.formatType : null,
                importType: exist? exist.importType : null,
                data: data.filter(i => i.length >= 1)
              });
            } else {
              this.snackBarService.show('Asegúrate de cargar los despachos', 'warning');
            }
          } else {
            this.snackBarService.show('Asegúrate que el archivo tenga el formato correcto', 'error');
          }
        }
      };
      reader.readAsBinaryString(event.target.files[0]);
      this.fileValue = null;
    }
  }
}
